
<template>
  <div class="record">
    <Head :info="headInfo"></Head>
    <div class="container">
        <van-collapse v-model="activeNames">
            <van-collapse-item :name="index" v-for="(item,index) in list" :key="item.type">
                <template #title>
                    <div class="titles"><span>{{item.time}}</span><span>已提现￥{{item.monthMoney}}</span></div>
                </template>
                <!-- <img src="../../assets/images/collapse.png" alt=""> -->
                <div class="each-charge" v-for="(each,index) in item.items" :key="each.money">
                    <img :src="each.paymentid==1?img1:(each.paymentid==2?img2:img3)" alt="">
                    <div :class="['each-state',{'no-border':index==item.items.length-1}]">
                        <div>
                            <div class="state">{{each.state}}</div>
                            <div class="each-time">{{each.paytime}}</div>
                        </div>
                    <div>{{each.money}}</div>
                    </div>
                </div>

            </van-collapse-item>
        </van-collapse>
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
import {ls} from '@/utils/localStorage'

// 组件
export default {
  name: 'myBank',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '提现记录'
        },
        activeNames:[],
        img1: require('../../assets/images/wx.png'),
        img2: require('../../assets/images/yinhang.png'),
        img3: require('../../assets/images/zfb.png'),
        list:[
            {
                time:'2020.09',
                monthMoney: '8089.34',
                item: [
                    {
                        type:1,
                        state:'已发放',
                        paytime:'09月12日 11:00',
                        money: '192.09'
                    },{
                        type:2,
                        state:'已发放',
                        time:'09月12日 11:00',
                        total: '192.09'
                    },{
                        type:3,
                        state:'已发放',
                        time:'09月12日 11:00',
                        total: '192.09'
                    }
                ]
            }
        ]
        
    };
  },
  created() {
      this.getList()
  },
 mounted() {
 },
  methods: {
      getList() {
          let param= {
            //   refereeId:ls.get('refereeId')
          }
          this.$services.txRecord({method:'post',data:param}).then(res=> {
              this.list = res.data
          })
      }
  }
};
</script>

<style lang="less" scoped>
.record{ 
    background-color: @colorBg;
     .container{
         padding: 13px;
     }
     /deep/.van-collapse-item{
         margin-bottom: 11px;
        border-radius: 10px;
        overflow: hidden;
     }
     .titles{
         display: flex;
         justify-content: space-between;
         img{
             width: 16px;
             height: 16px;
         }
     }
     /deep/.van-cell__right-icon{
            width: 20px;
             height: 20px;
             display: flex;
             justify-content: center;
             align-items: center;
     }
     .each-charge{
         display: flex;
         justify-content: space-between;
         align-items: stretch;
         height: 70px;
         &>img{
             width: 31px;
             height: 31px;
             align-self:center;
         }
         
         .each-state{
             display: flex;
             align-items: center;
             justify-content: space-between;
             border-bottom: 1px solid #F1F1F1;
             &>div{
                 display: flex;
                 flex-direction: column;
                 align-items: flex-start;
             }
             flex: 1;
             padding-left: 17px;
             color: @colorFont;
             font-size: 15px;
             .state{
                 height: 18px;
                 min-width: 10px;
             }
             .each-time{
                 color: #999999;
                 font-size: 13px;
             }
         }
         .no-border{
             border-bottom: none;
         }
         
     }
     /deep/.van-collapse-item__title{
         position: relative;
         .van-icon-arrow{
             position: absolute;
             left: 80px;
             top: 12px;
             width: 20px;
             height: 20px;
             background-color: #eeeeee;
             border-radius: 50%;
         }
     }
}
</style>
